import React from 'react';
function UpSmall({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path stroke="transparent" fill="currentColor" d="M12 10l3.464 3.75H8.536L12 10z" />
    </svg>
  );
}

export default UpSmall;
